module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-ties-remnants.6d8b3c64.png";